<template>
  <el-checkbox v-model="value" @update:modelValue="input">
    Block noref traffic
    <IconWithHint> Traffic with empty Referer HTTP header </IconWithHint>
  </el-checkbox>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import IconWithHint from '@/components/IconWithHint.vue'

export default defineComponent({
  name: 'BlockNoRef',
  components: {
    IconWithHint
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)

    function input(newValue: boolean) {
      context.emit('update:modelValue', newValue)
    }

    return { input, value }
  }
})
</script>
